import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const inventoryMovementTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "inventory.movement-trend",
  name: "Stock movement trend",
  description: "Stock movement trend across the selected period.",
  apps: [
    "home",
    "inventory",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "inventory.stock-events",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "quantity",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Units",
        query: {
          version: 1,
          source: "inventory.stock-events",
          ...period(30),
          select: [
            {
              type: "field",
              field: "created_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "quantity",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "created_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Stock movement trend",
    valueFormat: "number",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "1,450",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
